import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import './assets/style/theme.less'

const app = createApp(App)
app.use(Antd).use(store).use(router).mount('#app')

app.config.globalProperties.$filters = {
  formatNumber(value) {
    if (value) {
      return value.toLocaleString()
    }
    return ''
  }
}

console.log = (function (log) {
  return import.meta.env.VITE_APP_NO_CONSOLE == '1' ? function () {} : log
})(console.log)
